import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseHighlight() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("لطفا اطلاعات خصوصیت را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getHighlightList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Highlights?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getHighlightByID = (id, callback) => {
    MyAxios.get(`Admin_Highlights/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateHighlight = (state, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file) {
      data.append("file", file);
    }

    MyAxios.post(`Admin_Highlights`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("خصوصیت با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addHighlight = (state, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file) {
      data.append("file ", file);
    }
    MyAxios.post(`Admin_Highlights`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("خصوصیت با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteHighlight = (id, callback) => {
    const data = new FormData();
    data.append("HighlightID", id);
    MyAxios.delete(`Admin_Highlights`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("خصوصیت با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getHighlightList,
    getHighlightByID,
    validate,
    updateHighlight,
    addHighlight,
    deleteHighlight,
  };
}
